import React from "react";
import { motion } from "framer-motion";
import "./PostSkeleton.css";

const PostSkeleton = () => {
  return (
    <motion.div
      className="cbx-skeleton"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.3 }}
    >
      {/* Header */}
      <div className="cbx-skeleton-header">
        <div className="cbx-skeleton-avatar" />
        <div className="cbx-skeleton-author">
          <div className="cbx-skeleton-name" />
          <div className="cbx-skeleton-meta" />
        </div>
      </div>

      {/* Content */}
      <div className="cbx-skeleton-content">
        <div className="cbx-skeleton-line" />
        <div className="cbx-skeleton-line cbx-skeleton-line--medium" />
        <div className="cbx-skeleton-line cbx-skeleton-line--short" />
      </div>

      {/* Actions */}
      <div className="cbx-skeleton-actions">
        <div className="cbx-skeleton-action" />
        <div className="cbx-skeleton-action" />
        <div className="cbx-skeleton-action" />
        <div className="cbx-skeleton-action" />
        <div className="cbx-skeleton-action" />
      </div>
    </motion.div>
  );
};

export default PostSkeleton;
